var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadFile24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#1976d2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M14.29.822l6.342 6.342V21.92a1.26 1.26 0 0 1-1.26 1.26H4.601a1.26 1.26 0 0 1-1.26-1.26V2.082c0-.696.564-1.26 1.26-1.26h9.689zm.896 3.52v1.932h1.932l-.964-.964-.968-.968zm3.48 16.858V8.15H14.67c-.615 0-1.113-.519-1.113-1.157V2.832H5.335V21.2h13.331zm-9.565-7.894a.707.707 0 1 1 1-1l1.178 1.178v-4.8a.707.707 0 1 1 1.415 0v4.886l1.284-1.284a.707.707 0 1 1 1 1l-2.334 2.335a.7.7 0 0 1-.283.17.704.704 0 0 1-.874-.1L9.1 13.307zm-1.039 3.395h7.849v-1.274a.707.707 0 1 1 1.415 0v1.98c0 .392-.317.708-.708.708H7.355a.707.707 0 0 1-.707-.707v-1.98a.707.707 0 1 1 1.414 0V16.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFile24);
export default __webpack_public_path__ + "static/media/download-file-24.abf90437.svg";
export { ForwardRef as ReactComponent };